import { Section } from "@components/ui/Section";
import styles from "./page.module.css";
import { Heading } from "@components/ui/Heading";

export const TermsAndConditions = () => {
  return (
    <Section className={styles.bgWhitePadding}>
      <div className={styles.mb4AllP}>
        <Heading level={2} className={styles.heading2}>
          Woolworths MarketPlus Site Terms & Conditions
        </Heading>
        <p>Welcome to Woolworths MarketPlus.</p>
        <p>
          The Woolworths MarketPlus (ABN 88 000 014 675) (<b>Woolworths Market Plus</b>) Site at{" "}
          <a
            className={styles.textWoolworthsBlue}
            href="https://www.woolworthsgroup.com.au/au/en/woolworths-market-plus.html"
          >
            https://www.woolworthsgroup.com.au/au/en/woolworths-market-plus.html
          </a>{" "}
          (<b>Site</b>) is made available by Woolworths Group Limited ABN 88 000
          014 675 (<b>Woolworths</b>).&nbsp;
        </p>
        <p>
          By using the Site and any related service or tool relating to the
          Site, you agree to be bound by the following terms and conditions (<b>Terms</b>).
        </p>
        <p>
          If you do not agree to these Terms, you should not use the Site. We
          reserve the right to change these Terms from time to time on
          reasonable notice. If you do not agree to an updated version of the
          Terms, you should cease using the Site.&nbsp;
        </p>
        <p>
          You should read all of these Terms. However{" "}
          <b>
            we have set out below some important terms that we don’t want you to
            miss
          </b>
          :
        </p>
        <ul className={styles.listDiscMb4}>
          <li>
            <p>
              Woolworths and its ‘related bodies corporate’, as that term is
              defined in the Corporations Act 2001 (Cth), (
              <b>Woolworths Group</b>) may use your data for the purposes of
              providing services through the Site, developing the Site or the
              services related to it, or any other reasonable purpose, provided
              that any personal information is used in a manner consistent with
              our Privacy Policy.
            </p>
          </li>
          <li>
            <p>
              Woolworths does not warrant that the Site is error free, fit for
              any particular purpose or will function in any specified
              manner.&nbsp;
            </p>
          </li>
          <li>
            <p>
              Woolworths may change these Terms from time to time on reasonable
              notice and may contact you as described in clause 5.2 in relation
              to such changes.
            </p>
          </li>
          <li>
            <p>
              Woolworths may stop making the Site available to you at any time
              without notice.
            </p>
          </li>
        </ul>
        <p>&nbsp;</p>
        <p>
          <b>1.&nbsp;&nbsp;&nbsp;&nbsp;Your use of the Site</b>
        </p>
        <p className={styles.ml8}>
          1.1.&nbsp;&nbsp;&nbsp;&nbsp;By accessing and using the Site, you
          acknowledge and agree:
        </p>
        <p className={styles.ml16}>
          (a) you must comply with all applicable laws and regulations when
          using the Site;
        </p>
        <p className={styles.ml16}>
          (b) the Site may contain errors and be unavailable from time to time;
        </p>
        <p className={styles.ml16}>
          (c) subject to applicable law (including the Competition and Consumer
          Act 2010 (Cth)), all express or implied guarantees, warranties,
          representations, statements, terms and conditions relating to these
          Terms that are not contained in these Terms, are excluded to the
          maximum extent permitted by law. Without excluding, restricting or
          modifying the rights and remedies to which you may be entitled under
          the Competition and Consumer Act 2010 (Cth) or our liability under
          these provisions:
        </p>
        <p className={styles.ml24}>
          (i) you acknowledge that the Site is provided “as is” and Woolworths
          Group does not make any representation or warranty as to the
          suitability of the Site or any functionality provided within the Site;
          and
        </p>
        <p className={styles.ml24}>
          (ii) you acknowledge that to the maximum extent permitted by
          applicable law, Woolworths Group will not be liable to you in
          connection with your use of this Site for any loss or damage, except
          to the extent that such loss or damage arises as a result of our own
          negligence or wilful misconduct;
        </p>
        <p className={styles.ml16}>
          (d) an internet connection is needed to access and use the Site and
          you are responsible for any related charges;
        </p>
        <p className={styles.ml16}>
          (e) the Site may contain links to external websites that are not
          operated by us or our related bodies corporate. These links are
          provided for convenience only and you agree that:
        </p>
        <p className={styles.ml24}>
          (i) we make no representation or warranties, and have no
          responsibility or liability, for those sites;
        </p>
        <p className={styles.ml24}>
          (ii) these links do not indicate, expressly or impliedly, that we
          endorse the site, any opinions expressed on the site or any products
          or services that may be provided at those sites; and
        </p>
        <p className={styles.ml24}>
          (iii) you access the content and use any products or services made
          available or advertised at those sites solely at your own risk;
        </p>
        <p className={styles.ml16}>
          (f) if you provide Woolworths Group with any information via the Site:
        </p>
        <p className={styles.ml24}>
          (i) you are responsible for providing that information to Woolworths
          Group, including the accuracy of any such information; and
        </p>
        <p className={styles.ml24}>
          (ii) you acknowledge that Woolworths Group is not required, and has
          not made any commitment, to make contact with you or list you as a
          seller or any of your products on any Woolworths MarketPlus
          marketplace.&nbsp;
        </p>
        <p className={styles.ml8}>
          1.2.&nbsp;&nbsp;&nbsp;&nbsp;You must not use the Site to:
        </p>
        <p className={styles.ml16}>
          (a) make fraudulent or speculative enquiries or requests;
        </p>
        <p className={styles.ml16}>
          (b) breach or contradict any laws, regulations, standards or codes;
        </p>
        <p className={styles.ml16}>
          (c) transmit any material that interferes with the Site or other users
          in a way that may defame, harass, threaten, menace or offend any
          person, or prevents the Site from being used for its intended purpose;
        </p>
        <p className={styles.ml16}>
          (d) use another person’s details without their permission to
          impersonate another person;
        </p>
        <p className={styles.ml16}>
          (e) knowingly transmit any viruses, worms, defects, trojan horses or
          similar disabling or malicious code to the Site;
        </p>
        <p className={styles.ml16}>
          (f) use any robot, spider, retrieval system or other mechanism to
          retrieve or index any portion of the Site;
        </p>
        <p className={styles.ml16}>
          (g) remove any copyright, trade mark, or other proprietary rights
          notice contained in or on the Site;
        </p>
        <p className={styles.ml16}>
          (h) infringe the Intellectual Property Rights (as defined below) of
          Woolworths Group or any other third party;
        </p>
        <p className={styles.ml16}>
          (i) reformat or frame any portion of the Site;
        </p>
        <p className={styles.ml16}>
          (j) submit information on the Site by automated means or under false
          or fraudulent pretences;
        </p>
        <p className={styles.ml16}>
          (k) use the Site to violate the security of any computer or other
          network, or engage in illegal conduct;
        </p>
        <p className={styles.ml16}>
          (l) take any action that imposes, or that would, in our reasonable
          opinion, result in an unreasonable load on our infrastructure; or
        </p>
        <p className={styles.ml16}>
          (m) attempt, or engage or permit another person to do or attempt to
          do, any of the above actions.
        </p>
        <p>&nbsp;</p>
        <p>
          <b>2.&nbsp;&nbsp;&nbsp;&nbsp;Privacy</b>
        </p>
        <p className={styles.ml8}>
          2.1.&nbsp;&nbsp;&nbsp;&nbsp;Woolworths Group collects and uses your
          personal information (including your name, email and phone number) to
          communicate with you about Woolworths Market Plus or any Woolworths
          Market Plus marketplaces. Personal information is held on the public
          register in accordance with Chapter 2C of the Corporations Act 2001.
          We have global support services and we may sometimes need to share
          personal information overseas, for instance while using cloud
          computing services. For details about Woolworths Group’s privacy
          practices, including how you may access and correct your personal
          information and raise privacy concerns, see the Woolworths Group
          Privacy Policy, accessible at{" "}
          <a
            className={styles.textWoolworthsBlue}
            href="https://www.woolworthsgroup.com.au/au/en/privacy/policy-documents/privacy-policy.html"
          >
            https://www.woolworthsgroup.com.au/au/en/privacy/policy-documents/privacy-policy.html
          </a>
          .
        </p>
        <p className={styles.ml8}>
          2.2.&nbsp;&nbsp;&nbsp;&nbsp;You must comply with the Privacy Act 1988
          (Cth) as if bound by it while using the Site.
        </p>
        <p className={styles.ml8}>
          2.3.&nbsp;&nbsp;&nbsp;&nbsp;You must give all assistance we reasonably
          request, and comply with all reasonable directions we may issue from
          time to time, in relation to our compliance with the Privacy Act 1988
          (Cth) or any investigation, request or enquiry from the Australian
          Information Commissioner and Privacy Commissioner or other relevant
          regulator regarding personal information disclosed in your use of the
          Site.
        </p>
        <p className={styles.ml8}>
          2.4.&nbsp;&nbsp;&nbsp;&nbsp;You must notify us if you become aware of
          any breach of this clause.
        </p>
        <p>&nbsp;</p>
        <p>
          <b>3.&nbsp;&nbsp;&nbsp;&nbsp;Data Usage</b>
        </p>
        <p className={styles.ml8}>
          3.1.&nbsp;&nbsp;&nbsp;&nbsp;You agree that, when accessing or using
          the Site:
        </p>
        <p className={styles.ml16}>
          (a) Woolworths Group may collect, use, store and disclose information
          about use of the Site; and
        </p>
        <p className={styles.ml16}>
          (b) technical data and related information, including but not limited
          to information about your device, system, software and peripherals,
          may be gathered periodically.
        </p>
        <p className={styles.ml8}>
          3.2.&nbsp;&nbsp;&nbsp;&nbsp;You grant to Woolworths Group a
          non-exclusive and royalty free licence to use your data for the
          purposes of providing services through the Site, developing the Site
          or the services related to it or any other reasonable purpose. We
          agree that any use of your personal information will be subject to
          clause 2 (Privacy).
        </p>
        <p>&nbsp;</p>
        <p>
          <b>4.&nbsp;&nbsp;&nbsp;&nbsp;Intellectual Property Rights</b>
        </p>
        <p className={styles.ml8}>
          4.1.&nbsp;&nbsp;&nbsp;&nbsp;You acknowledge that all elements of the
          Site are owned by or licensed to Woolworths Group, including (but not
          limited to) copyright in any software, design, text and graphics in
          the Site, the Site layout and the content and material on the Site (
          <b>Site Materials</b>).
        </p>
        <p className={styles.ml8}>
          4.2.&nbsp;&nbsp;&nbsp;&nbsp;Woolworths Group does not assign to you or
          create for your benefit, any Intellectual Property Rights (including
          future Intellectual Property Rights) or any material otherwise created
          by Woolworths Group in the delivery of the Site.
        </p>
        <p className={styles.ml8}>
          4.3.&nbsp;&nbsp;&nbsp;&nbsp;You must not copy, modify, adapt, store in
          a retrieval system, reproduce, upload or sell any part of the Site
          Materials without Woolworths Group’s prior written consent.
        </p>
        <p className={styles.ml8}>
          4.4.&nbsp;&nbsp;&nbsp;&nbsp;You must not use Woolworths Group or
          Woolworths MarketPlus trade marks or logos without Woolworths Group’s
          prior written consent.&nbsp;
        </p>
        <p className={styles.ml8}>
          4.5.&nbsp;&nbsp;&nbsp;&nbsp;You must not infringe any Intellectual
          Property Rights or other rights of any third party in your use of the
          Site.
        </p>
        <p className={styles.ml8}>
          4.6.&nbsp;&nbsp;&nbsp;&nbsp;For the purpose of these Terms,
          <b> Intellectual Property Rights</b> means all intellectual property
          rights, including (but not limited to) current and future registered
          and unregistered rights in respect of copyright, designs, circuit
          layouts, trade marks, trade secrets, know-how, confidential
          information, patents, invention and discoveries, and all other
          intellectual property as defined in article 2 of the convention
          establishing the World Intellectual Property Organisation 1967.
        </p>
        <p>&nbsp;</p>
        <p>
          <b>5.&nbsp;&nbsp;&nbsp;&nbsp;Notifications and communications</b>
        </p>
        <p className={styles.ml8}>
          5.1.&nbsp;&nbsp;&nbsp;&nbsp;You agree that you may receive service
          emails from Woolworths Group regarding the Site.
        </p>
        <p className={styles.ml8}>
          5.2.&nbsp; &nbsp; If you opt out of receiving notifications or
          communications from Woolworths Group, you will still receive
          information we are required by law to provide you, including changes
          to these terms and conditions, and/or our privacy policy or other
          information relating to your interactions with Woolworths
          MarketPlus.&nbsp;
        </p>
        <p className={styles.ml8}>
          5.3.&nbsp;&nbsp;&nbsp;&nbsp;You agree that we and any Woolworths
          MarketPlus marketplace may send you commercial electronic messages and
          tailored advertising (which include marketing communications
          advertising goods and services) via various channels and media
          (including by email, SMS, phone and mail) about Woolworths, Woolworths
          MarketPlus, the Woolworths MarketPlus marketplaces and your use of
          Woolworths MarketPlus where you have not opted out (as described
          below) from receiving such electronic messages sent to you by
          Woolworths, Woolworths MarketPlus or any Woolworths MarketPlus
          marketplaces via these channels or media. Your agreement to receive
          these commercial electronic messages will be effective until you opt
          out.
        </p>
        <p className={styles.ml8}>
          5.4.&nbsp;&nbsp;&nbsp;&nbsp;If you want to update where we send the
          communications referred to in clause 5.3, you may contact us at{" "}
          <a
            className={styles.textWoolworthsBlue}
            href="mailto:sellersupport@woolworths.com.au"
          >
            sellersupport@woolworths.com.au
          </a>
          . Please note that if you update your contact details, it may take up
          to 5 business days before we send communications to the updated
          address, so the relevant person may still receive communications from
          us at their previous contact details during this time.
        </p>
        <p className={styles.ml8}>
          5.5.&nbsp;&nbsp;&nbsp;&nbsp;You may opt out of receiving commercial
          electronic messages by following the directions to unsubscribe in the
          footer of any commercial electronic messages. If you tell us you want
          to opt out of the receipt of such messages, your request will apply
          only to the electronic address to which the commercial electronic
          message was sent. Within 5 business days of receiving that request and
          subject to clause 5.2 and 5.6, we will cease to send commercial
          electronic messages to that address.
        </p>
        <p className={styles.ml8}>
          5.6.&nbsp;&nbsp;&nbsp;&nbsp;Opting out of receiving commercial
          electronic messages from us or from a specific Woolworths MarketPlus
          marketplace will not withdraw your consent to receive messages from
          other Woolworths Group brands or other Woolworths MarketPlus
          marketplaces. Any consent you have provided to receive commercial
          electronic messages from other Woolworths Group brands are governed
          under separate terms and conditions that apply to those other
          Woolworths Group brands. If you would like to opt out of receiving
          commercial electronic messages from other Woolworths Group brands, you
          can do so by following the opt out facilities in those other
          Woolworths Group brand messages sent to you or other opt out options
          set out in those Woolworths Group brands’ relevant terms and
          conditions.
        </p>
        <p>&nbsp;</p>
        <p>
          <b>6.&nbsp;&nbsp;&nbsp;&nbsp;Governing Law</b>
        </p>
        <p className={styles.ml8}>
          6.1.&nbsp;&nbsp;&nbsp;&nbsp;These Terms are governed by the laws of
          New South Wales, Australia. Each party agrees to the non-exclusive
          jurisdiction of the courts of New South Wales, Australia. Any rights
          or remedies to which you are entitled under the Competition and
          Consumer Act 2010 (Cth) arise independently of these Terms and this
          clause does not apply to any claim you may have under the Competition
          and Consumer Act 2010 (Cth).
        </p>
        <p className={styles.ml8}>
          6.2.&nbsp;&nbsp;&nbsp;&nbsp;If the whole or any part of a provision of
          these Terms is void, unenforceable or illegal in any jurisdiction, it
          is severed for that jurisdiction. The remainder of these Terms has
          full force and effect, and the validity or enforceability of that
          provision in any other jurisdiction is not affected.
        </p>
      </div>
    </Section>
  );
};
